import React, { Component } from 'react';
import moment from 'moment';
import _ from 'lodash';
import { inject, observer } from 'mobx-react';
import { CellUnits, ViewTypes } from '../../../components/Scheduler';
import Scheduler, { DATE_FORMAT, SchedulerData } from './RosterScheduler'
import { Modal, Col, Row } from 'react-bootstrap';

//components
import withLocalization from '../../../hoc/withLocalization';
import withDragDropContext from '~/hoc/withDnDContext';
import Calendar from '../../../components/ReactCalendar';
import Button from '../../../components/CustomButton/CustomButton.jsx';

//elements
import Select from '../../../elements/Select.js';
import RequiredStar from '../../../elements/RequiredStar.js';
import LoadingSpinner from '~/elements/LoadingSpinner';

//assests
import CloseModalIcon from '../../../assets/img/CloseApproveModalIcon.svg';
import bulbIcon from '../../../assets/img/bulb.svg';

//utils
import { getMomemntLocale, removeEmptyObjects } from '../../../utils/commonMethods.js';
import { isoWeekdayMap } from '../../../utils/constants.js'
import CustomMultiSelect from '../../../elements/CustomMultiSelect.js';
import { CurrentUserGroupsWidget } from '../../../components/GenericForm/Widgets/UserGroupWidget.js';

const getUserOptions = (users, cycleData) => {
    const filteredCycleData = removeEmptyObjects(cycleData);
    const allUsers = users.map(ele => ({ label: ele.name, value: ele.id }));
    const filteredUsers = allUsers.filter(item => filteredCycleData[item.value])
    return { allUsers, filteredUsers };
}

const getWeekArray = () => Array.from({ length: 53 }, (_, i) => i + 1);

const getUpdatedCycleData = (fromWeeks, toWeeks, cycleData, valuesCycleData, commonStore, cycleDetails) => {
    const newCycleData = _.cloneDeep(cycleData);
    const history = [];
    const cycleStartYear = moment(cycleDetails.startDate).isoWeekYear();
    const cycleEndYear = moment(cycleDetails.endDate).isoWeekYear();

    const userIds = Object.keys(newCycleData);
    userIds.forEach(userId => {
        toWeeks.forEach((weekNumToSet, index) => {
            const weekNumToPick = fromWeeks[index % fromWeeks.length];
            const dataToPick = valuesCycleData[weekNumToPick];
            if (!dataToPick) return;
            const weekData = {};
            Object.entries(dataToPick).forEach(([day, shift]) => {
                const isoDayNumber = isoWeekdayMap[day];
                let weekMoment = moment().isoWeekYear(cycleStartYear).isoWeek(weekNumToSet).isoWeekday(isoDayNumber);
                if (cycleEndYear !== cycleStartYear && !weekMoment.isBetween(cycleDetails.startDate, cycleDetails.endDate, null, '[]')) {
                    weekMoment = moment().isoWeekYear(cycleEndYear).isoWeek(weekNumToSet).isoWeekday(isoDayNumber);
                }
                const date = weekMoment.format('YYYY-MM-DD');
                weekData[day] = { ...shift, date };
                const companyShift = commonStore.getCompanyShift(shift.shiftCodeId);
                history.push({
                    ...shift,
                    id: `${date}_${userId}`,
                    resourceId: Number(userId),
                    title: companyShift.short_code,
                    for_date: date,
                    start: `${date} 00:00`,
                    end: `${date} 23:00`,
                    startTime: 0,
                    endTime: 1440
                });
            });
            newCycleData[userId][weekNumToSet] = weekData;
        });
    });

    return {
        detailedCopiedShifts: history,
        currentCopiedShifts: newCycleData
    };
};

class CopyWeeks extends Component {
    constructor(props) {
        super(props);
        this.state = {
            user: null,
            fromWeeks: [],
            toWeeks: [],
            userOptions: [],
            allUserOptions: [],
            selectedUsers: [],
            activeStartDate: new Date(props.cycleDetails.startDate),
            activeEndDate: new Date(props.cycleDetails.startDate),
            disableFromWeeks: [],
            showCopiedShifts: false,
            copyMode: '',
            detailedCopiedShifts: [],
            currentCopiedShifts: null,
            user_group: -1,
            groupDetails: [],
            schedulerData: null,
            width: 0,
            isLoading: false
        };
        this.scheduleRef = React.createRef();
    }

    updateWidth = () => {
        if (this.scheduleRef.current)
            this.setState({ width: this.scheduleRef.current.offsetWidth });
    };

    componentDidMount() {
        const { isSingleCopy, cycleData, users, cycleDetails } = this.props;
        const { allUsers = [], filteredUsers = [] } = getUserOptions(users, cycleData)
        this.setState({ userOptions: filteredUsers, allUserOptions: allUsers, copyMode: isSingleCopy ? 'single' : '' });
        window.addEventListener('resize', this.updateWidth);
    }

    componentDidUpdate(_, prevState) {
        if (prevState.isLoading && !this.state.isLoading) {
            this.updateWidth();
        }
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWidth);
    }

    initRosterScheduler = () => {
        const { t } = this.props;
        const { detailedCopiedShifts, allUserOptions, selectedUsers, copyMode, user } = this.state;
        let rosterSchedulerData = new SchedulerData(
            moment().format('YYYY-MM-DD'),
            ViewTypes.Custom1,
            false,
            false,
            {
                headerEnabled: false,
                startResizable: false,
                endResizable: false,
                movable: false,
                creatable: false,
                resourceName: `${t('Name')}`,
                nonAgendaOtherCellHeaderFormat: 'ddd | D',
                schedulerWidth: '78%',
                tableHeaderHeight: 75,
                eventItemHeight: 40,
                eventItemLineHeight: 40,
                yearCellWidth: 60,
            },
            { getCustomDateFunc: this.getCustomDate },
        );
        rosterSchedulerData.localeMoment.locale('en');
        const users = allUserOptions.filter(item => copyMode === 'others' ? selectedUsers.includes(item.value) : [user.value].includes(item.value)).map(ele => ({ id: ele.value, name: ele.label }))
        rosterSchedulerData.setResources(users);
        rosterSchedulerData.setEvents(detailedCopiedShifts);
        this.setState({ schedulerData: rosterSchedulerData, showCopiedShifts: true, isLoading: false })
    }

    getCustomDate = () => {
        const { cycleDetails } = this.props;
        return {
            startDate: moment(cycleDetails.startDate).format(DATE_FORMAT),
            endDate: moment(cycleDetails.endDate).format(DATE_FORMAT),
            cellUnit: CellUnits.Day
        };
    }

    onHandleWeek(week, source) {
        const weeks = this.state[source];
        if (weeks.indexOf(week) >= 0) {
            weeks.splice(weeks.indexOf(week), 1);
        } else {
            weeks.push(week);
        }
        this.setState({ [source]: weeks });
    }

    renderFromWeeks = () => {
        const { fromWeeks } = this.state;
        return fromWeeks.sort((a, b) => a - b).map((w, idx) => {
            return (
                <span key={idx}>
                    {w}
                    {idx < fromWeeks.length - 1 ? ', ' : ''}
                </span>
            );
        });
    };

    handleMonthNavigation = (label, value) => {
        const { cycleDetails } = this.props;
        if (label === 'from') {
            if (moment(value.activeStartDate).isBetween(moment(cycleDetails.startDate).subtract(1, 'month'), moment(cycleDetails.endDate), null, '[]'))
                this.setState({ activeStartDate: value.activeStartDate })
        }
        else {
            if (moment(value.activeStartDate).isBetween(moment(cycleDetails.startDate).subtract(1, 'month'), moment(cycleDetails.endDate), null, '[]'))
                this.setState({ activeEndDate: value.activeStartDate })
        }
    }

    handleUserChange = (user) => {
        const { cycleData } = this.props;
        const selectedUserData = cycleData[user.value]
        const data = removeEmptyObjects(selectedUserData)
        const elementToEliminate = Object.keys(data).map(ele => parseInt(ele));
        const weekToFilter = getWeekArray();
        const result = weekToFilter.filter(item => !elementToEliminate.includes(item));
        this.setState({ user, disableFromWeeks: result })
    }

    handleCopy = () => {
        const { cycleData, commonStore, t } = this.props;
        const { toWeeks, fromWeeks, user, selectedUsers, copyMode } = this.state;

        if (!user?.value)
            return commonStore.addNotification(t('Please choose the user to perform the copying of shifts'), null, 'warning', "top-right", 3000);

        if (copyMode === 'others' && !selectedUsers.length)
            return commonStore.addNotification(t('Please Select the users to complete the copying of shifts'), null, 'warning', "top-right", 3000);

        if (fromWeeks.length > toWeeks.length) {
            return commonStore.addNotification(t('Target weeks(to weeks) should be equal to or greater than source weeks(from weeks). Source weeks will repeat automatically if needed.'), null, 'warning', "top-right", 3000);
        }

        const getCycleDataForSelectedUser = {};
        if (copyMode === 'others') {
            for (const id of selectedUsers) {
                if (cycleData[id]) getCycleDataForSelectedUser[id] = cycleData[id];
            }
        } else
            getCycleDataForSelectedUser[user.value] = cycleData[user.value];

        const getCycleDataForCopying = cycleData[user.value];
        const { currentCopiedShifts = {}, detailedCopiedShifts = {} } = getUpdatedCycleData(fromWeeks, toWeeks, getCycleDataForSelectedUser, getCycleDataForCopying, commonStore, this.props.cycleDetails);
        this.setState({ currentCopiedShifts, detailedCopiedShifts, isLoading: true }, () => this.initRosterScheduler());
    }

    handleSave = () => {
        const { updateCycleData, cycleData } = this.props;
        const { currentCopiedShifts } = this.state;
        const _updateCycleData = { ...cycleData, ...currentCopiedShifts };
        updateCycleData(_updateCycleData)
        this.props.closeModal();
    }

    handleModeSelect = async (mode) => {
        const { userGroupStore } = this.props;
        const groupDetails = mode === 'others' ? await userGroupStore.getGroupDetails({ include_user_details: true }) : [];
        this.setState({ copyMode: mode, groupDetails });
    }

    customEventItemTemplate = (_, eventItem) => {
        return (
            <div style={{ marginX: 'auto', marginTop: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 'bold', color: 'black' }}>
                <div style={{ fontSize: '12px' }}>{eventItem.title}</div>
            </div>
        );
    };

    render() {
        const { t, cycleData, commonStore, cycleDetails } = this.props;
        const { fromWeeks, toWeeks, activeStartDate, activeEndDate, disableFromWeeks, allUserOptions, user_group, groupDetails,
            userOptions, user, showCopiedShifts, copyMode, isLoading } = this.state;
        const userData = cycleData[user?.value];
        const dateTimeRules = commonStore.getDateTimeRules();

        const getTileClass = (p, lookInFrom) => {
            if (lookInFrom) {
                const weekData = userData?.[moment(p.date).isoWeek()];
                const currentDay = moment(p.date).format('dddd').toLocaleLowerCase();
                if (weekData?.[currentDay])
                    return 'day-week-selected-to'
            }
            return '';
        };

        let filteredUsers = allUserOptions;
        if (!showCopiedShifts && copyMode === 'others' && user_group > 0) {
            filteredUsers = allUserOptions.filter(r => (user_group > 0 ? (!!groupDetails.find(g => g.code === user_group && g.userIds.includes(r.value))) : true));
        }

        return (
            <Modal className="xl" size="xl" show backdrop="static" onHide={() => this.props.closeModal()}>
                <Modal.Header className="set_ModalHeader">
                    <Modal.Title>{this.props.t('Copy roster')}</Modal.Title>
                    <img
                        src={CloseModalIcon}
                        className="cursor-pointer"
                        onClick={() => this.props.closeModal()}
                    />
                </Modal.Header>
                <Modal.Body>
                    <>
                        {!copyMode ?
                            <Row style={{ minHeight: 300 }} className='justify-content-evenly'>
                                <Col md={5} style={{ border: '5px dashed #2550AC', borderRadius: '10px', color: '#2550AC', backgroundColor: '#E5ECFF' }} onClick={() => this.handleModeSelect('single')} className="p-4 d-flex align-items-center cursor-pointer justify-content-center">
                                    <div className='d-flex flex-column align-items-center justify-content-center' >
                                        <i className="fas fa-user me-2 fs-1" />
                                        <span className='fw-600'>{t('Single User')}</span>
                                    </div>
                                </Col>
                                <Col md={5} style={{ border: '5px dashed #2550AC', borderRadius: '10px', color: '#2550AC', backgroundColor: '#ebe8d0' }} onClick={() => this.handleModeSelect('others')} className="p-4 d-flex align-items-center cursor-pointer justify-content-center">
                                    <div className='d-flex flex-column align-items-center justify-content-center' >
                                        <i className="fas fa-users me-2 fs-1" />
                                        <span className='fw-600'>{t('Other Users')}</span>
                                    </div>
                                </Col>
                            </Row>
                            :
                            isLoading ?
                                <LoadingSpinner />
                                :
                                showCopiedShifts ?
                                    <>
                                        <i className='fw-600'>{t('Here is the copied roster for the selected members. Please confirm and click on save to proceed')}</i>
                                        {this.state.schedulerData && (
                                            <div ref={this.scheduleRef} className='mt-3'>
                                                <div id='Roster-Scheduler'>
                                                    <Scheduler
                                                        width={this.state.width}
                                                        schedulerData={this.state.schedulerData}
                                                        eventItemTemplateResolver={this.customEventItemTemplate}
                                                        isTemplateView={true}
                                                        dateTimeRules={dateTimeRules}
                                                        t={t}
                                                    />
                                                </div>
                                            </div>
                                        )}
                                    </>
                                    :
                                    <>
                                        <div className="row mb-2">
                                            <Col md={copyMode === 'others' ? 4 : 6}>
                                                <label className="control-label">{t('Available plan to Copy')}<RequiredStar /></label>
                                                <Select
                                                    options={userOptions}
                                                    value={userOptions.find(ele => ele.value === user)}
                                                    onChange={selected => this.handleUserChange(selected)}
                                                />
                                            </Col>
                                            {copyMode === 'others' &&
                                                <>
                                                    <Col md={copyMode === 'others' ? 4 : 6}>
                                                        <label className="control-label mb-1">
                                                            {`${t('Select')} ${t('Group')}`}
                                                        </label>
                                                        <CurrentUserGroupsWidget
                                                            value={user_group}
                                                            onChange={value => this.setState({ user_group: value })}
                                                        />
                                                    </Col>
                                                    <Col md={copyMode === 'others' ? 4 : 6}>
                                                        <label className="control-label">{t('Select members')}<RequiredStar /></label>
                                                        <CustomMultiSelect
                                                            options={filteredUsers.filter(ele => ele.value !== user?.value)}
                                                            value={this.state.selectedUsers}
                                                            onChange={selected => this.setState({ selectedUsers: selected })}
                                                            overrideStrings={{
                                                                selectSomeItems: t('Select Members'),
                                                                allItemsAreSelected: t('All members are selected'),
                                                                search: t('Search'),
                                                                selectAll: t('Select All'),
                                                                noOptions: t('No Options')
                                                            }}
                                                        />
                                                    </Col>
                                                </>
                                            }
                                        </div>
                                        <div className="row">
                                            <div
                                                className="col-md-6 d-flex flex-column align-items-center">
                                                <label className='text-primary font-size-15 mb-2 fw-bold'>
                                                    {t('Copy')} {t('from')} {t('Weeks')}:
                                                    <span className='text-secondary ps-1'>
                                                        {this.renderFromWeeks()}
                                                    </span>
                                                </label>
                                                <Calendar
                                                    locale={getMomemntLocale()}
                                                    t={t}
                                                    activeStartDate={activeStartDate}
                                                    onActiveStartDateChange={(a, v) => this.handleMonthNavigation('from', a)}
                                                    showFixedNumberOfWeeks
                                                    showWeekNumbers
                                                    checkedWeekNumbers={fromWeeks}
                                                    disabledWeekNumbers={disableFromWeeks}
                                                    onClickWeekNumber={(week) => this.onHandleWeek(week, 'fromWeeks')}
                                                    tileClassName={(params) => getTileClass(params, true)}
                                                />
                                            </div>
                                            <div
                                                className="col-md-6 d-flex flex-column align-items-center">
                                                <label className='text-primary font-size-15 mb-2 fw-bold'>
                                                    {t('Copy')} {t('to')} {t('Weeks')}:
                                                    <span className='text-secondary ps-1'>
                                                        {_.orderBy(toWeeks, (r) => r).join(', ')}
                                                    </span>
                                                </label>
                                                <Calendar
                                                    locale={getMomemntLocale()}
                                                    t={t}
                                                    activeStartDate={activeEndDate}
                                                    onActiveStartDateChange={(a, v) => this.handleMonthNavigation('to', a)}
                                                    showFixedNumberOfWeeks
                                                    showWeekNumbers
                                                    checkedWeekNumbers={toWeeks}
                                                    disabledWeekNumbers={copyMode === 'others' ? [] : fromWeeks}
                                                    onClickWeekNumber={(week) => this.onHandleWeek(week, 'toWeeks')}
                                                    tileClassName={(params) => getTileClass(params, false)}
                                                    includeWeeksFromRange={cycleDetails}
                                                />
                                            </div>
                                        </div>
                                        <div className='mt-2 fs14 color-2550AC'>
                                            <div className='fw-600'>
                                                <img src={bulbIcon} className='mb-1' alt='bulb-icon' />
                                                <span className='fw-600 text-dark'>{t('Note')}</span>: {t('If the number of target weeks(to weeks) is greater than the selected source weeks(from weeks), the system will repeat the source weeks(from weeks) in order until all target weeks(to weeks) are filled.')}
                                            </div>
                                            <br />
                                            <div className='fw-600 mt-2'>
                                                <span className='fw-600 text-dark'>{t('Example')}</span>: {t('If you select source weeks(from weeks) 14, 15 and target weeks(to weeks) 16, 17, 18, the mapping will be: 14 → 16, 15 → 17, 14 → 18')}
                                            </div>
                                        </div>
                                    </>
                        }
                    </>
                </Modal.Body>
                <Modal.Footer className='d-flex justify-content-end me-3'>
                    {copyMode ?
                        <Button wd fill type="submit" onClick={() => showCopiedShifts ? this.handleSave() : this.handleCopy()}>
                            {showCopiedShifts ? t('Save') : t('Start Copy')}
                        </Button>
                        :
                        <></>
                    }
                </Modal.Footer>
            </Modal>
        );
    }
}

export const CopyWeeksNoDnD = inject('userStore', 'commonStore', 'scheduleStore', 'userGroupStore')(withLocalization(observer(CopyWeeks)));
export default inject('userStore', 'commonStore', 'scheduleStore', 'userGroupStore')(withLocalization(withDragDropContext(observer(CopyWeeks))));
